import { render, staticRenderFns } from "./EditTransfer.vue?vue&type=template&id=7a31671c&"
import script from "./EditTransfer.vue?vue&type=script&lang=js&"
export * from "./EditTransfer.vue?vue&type=script&lang=js&"
import style0 from "./EditTransfer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports